export default {
  geolocation: {
    lat: '24.7742',
    lng: '46.7386',
    label: '11441 Riyadh',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
